module.exports = __webpack_public_path__ + "static/media/bg16.32b1dd8d.jpg";